import { connect } from 'react-redux';

import { Entities, fetchAll, fetchAllCustomRepository, getEntities, patch, save, search } from 'src/common/index';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { push } from 'react-router-redux';
import { fetchCompanyOwnedBookingIntegrations } from 'src/actions/integrations';
import OfferPrintedCustomer from 'src/components/administration/offer-printed-customer/offer-printed-customer';

const mapStateToProps = state => {
    return {
        busCompany: getOwnCompany(state),
        selectedCompany: state.selectedCompany,
        integration: getEntities(state, Entities.BOOKING_INTEGRATION),
        offerPrintedCustomerRequests: getEntities(state, Entities.OFFER_PRINTED_CUSTOMER),
    };
};

const OfferPrintedCustomerContainer = connect(mapStateToProps, {
    fetchAll,
    fetchAllCustomRepository,
    fetchCompanyOwnedBookingIntegrations,
    patch,
    search,
    save,
    push,
})(OfferPrintedCustomer);

export default OfferPrintedCustomerContainer;
